<div class="dialog-container bg-{{ dialogSurfaceBackground }}">
  <div mat-dialog-title class="mat-mdc-dialog-title mdc-dialog__title">
    <ng-content select="[title]"></ng-content>
    <svg-icon
      *ngIf="showCloseIcon"
      src="assets/icons/icon-close.svg"
      class="close-icon icon-{{ dialogCloseIconColor }}"
      (click)="actionClicked.emit({ action: 'close' })"
      [svgStyle]="{ 'width.rem': 1, 'height.rem': 1 }"
    ></svg-icon>
  </div>
  <div
    mat-dialog-content
    class="mat-mdc-dialog-content mdc-dialog__content"
    [ngClass]="{
      'with-padding': addContentPadding,
      'invisible-scrollbar': !showScrollbar
    }"
  >
    <ng-content select="[content]"></ng-content>
  </div>
  <div
    mat-dialog-actions
    class="mat-mdc-dialog-actions mdc-dialog__actions"
    *ngIf="showActions"
  >
    <div
      class="d-flex justify-content-end"
      #customActionsContainer
      [class.custom-actions-container]="hasCustomActions"
    >
      <ng-content select="[actions]"></ng-content>
    </div>
    <ng-container *ngIf="!hasCustomActions">
      <app-button
        variant="modal"
        [color]="
          dialogType === 'confirmation' ? 'confirmation-secondary' : 'secondary'
        "
        sizeType="flexible"
        flexibleSize="sm"
        fontSize="lg"
        (click)="actionClicked.emit({ action: 'cancel' })"
      >
        {{ cancelText }}</app-button
      >
      <app-button
        variant="modal"
        [color]="
          dialogType === 'confirmation' ? 'confirmation-primary' : 'primary'
        "
        sizeType="flexible"
        flexibleSize="sm"
        fontSize="lg"
        [disabled]="confirmDisabled"
        (click)="actionClicked.emit({ action: 'confirm' })"
      >
        {{ confirmText }}</app-button
      >
    </ng-container>
  </div>
</div>
